import { getThemeColors } from '@utils/theme';

export const useTheme = (element = document.body) => getThemeColors(element);
